import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {IFiles} from '../../ViewItems/viewfiles/viewfiles.component';
import {IHttpSetting} from '../../../../interface/dataset-params';
import {HttpFormDataService} from '../../../../services/services';
import {GlobalObjectService} from '../../../../class/global-obj';
import {Router} from '@angular/router';

@Component({
    selector: 'noos-task-view',
    templateUrl: './task-view.component.html',
    styleUrls: ['./task-view.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
@NoosFormTypeService.register('taskview')
export class TaskViewComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    recordId: 0;

    fileList: IFiles[] = [];


    uid = '';

    data = [];
    setting: IHttpSetting;
    locale = 'tr';

    constructor(private httpService: HttpFormDataService, public router: Router) {
        this.setting = GlobalObjectService.getVar('setting');
        this.locale = this.setting.env[0].locale;
    }

    loadKPI(noCache = false) {
        this.httpService.dashboard_kpi(this.setting, this.uid, noCache).subscribe(ret => {
            if (ret.complete) {
                this.data = ret.data;
                console.log('----->', this.data);
            }
        });
    }

    ngOnInit(): void {
        Object.assign(this, this.prop.options);
    }


    ngAfterViewInit(): void {
        this.loadKPI(true);
    }

    openSF(relatedObjectId: any) {
        this.router.navigate(['/CRM/form2/31/16/' + relatedObjectId.toString()]);
    }
}
